<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="adaptationModal customerEdit"
      :title="disabled ? '详情' : model.customerID ? '编辑' : '新建'"
      width="1200px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="90px">
      <div class="editTitle">客户信息</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户编号" prop="outerNo">
            <el-input v-model="model.outerNo" placeholder="请输入客户编号" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="model.customerName" placeholder="请输入客户名称" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户简称">
            <el-input v-model="model.shortName" placeholder="请输入客户简称" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户地址">
            <el-input v-model="model.address" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系人" prop="contact">
            <el-input v-model="model.contact" placeholder="请输入联系人姓名" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系方式" prop="telephone">
            <el-input v-model="model.telephone" placeholder="请输入联系方式" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="付款条件" prop="zterm">
            <el-input v-model="model.zterm" placeholder="请输入付款条件" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="经销商等级">
            <el-input v-model="model.dealerLevel" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="销售员姓名">
            <el-input v-model="model.salesperson" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="纸质签约">
            <el-input v-model="model.paperSign" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户行业">
            <el-input v-model="model.industryName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户分类">
            <el-input v-model="model.classificationName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户属性">
            <el-input v-model="model.attributesName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商务专员">
            <el-input v-model="model.businessSpecialistName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所属BU">
            <el-input v-model="model.industryToWhichName" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">开票信息</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="开户行" label-width="75px">
            <el-input v-model="model.bank" placeholder="请输入开户行" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="账号" label-width="60px">
            <el-input v-model="model.accounts" placeholder="请输入开户行账号" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="税号" label-width="60px">
            <el-input v-model="model.vatno" placeholder="请输入税号" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">所属销售员</div>
      <el-row>
        <el-button type="primary" style="margin-bottom: 8px" @click="$refs.employeeSelect.open()"> 添加 </el-button>
        <Table border stripe :columns="columns" :data="model.customerBelongtoEmployeeVOS">
          <template slot="action" slot-scope="{ index }">
            <el-button type="danger" @click="model.customerBelongtoEmployeeVOS.splice(index, 1)">删除</el-button>
          </template>
          <template slot="isDefault" slot-scope="{ row, index }">
            <el-radio-group v-model="row.isDefault" @input="isDefaultChange(row, index)">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
          <template slot="belongType" slot-scope="{ row, index }">
            <el-radio-group v-model="row.belongType">
              <el-radio :label="10">销售员</el-radio>
              <el-radio :label="20">商务专员</el-radio>
            </el-radio-group>
          </template>
        </Table>
      </el-row>
      <div class="editTitle" style="margin-top: 10px">收货地址</div>
      <el-row>
        <el-button type="primary" style="margin-bottom: 8px" @click="$refs.customerAddressEdit.open()"> 添加 </el-button>
        <Table border stripe :columns="columnsTwo" :data="model.customerDeliveryAddresses">
          <template slot="area" slot-scope="{ row }">
            <el-cascader
                v-model="row.districtId" 
                class="cascader"
                :options="options"  
                style="width: 100%"  
                disabled/>
          </template>
          <template slot="action" slot-scope="{ index }">
            <el-button type="danger" @click="model.customerDeliveryAddresses.splice(index, 1)">删除</el-button>
          </template>
          <template slot="isDefault" slot-scope="{ row, index }">
            <el-radio-group v-model="row.isDefault" @input="isDefaultChangeTwo(row, index)">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </Table>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" type="primary" :loading="submitLoading" @click="handleOk">确定</el-button>
    </span>
    <employee-select ref="employeeSelect" @select="employeeSelect"/>
    <customer-address-edit ref="customerAddressEdit" :options="options" @save-success="deliveryAddressAdd"/>
  </el-dialog>
</template>

<script>
  import constant from "@/util/constant";
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import CustomerAddressEdit from "./CustomerAddressEdit.vue";
  export default {
    components: { EmployeeSelect, CustomerAddressEdit },
    props: {
      options: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },

    data() {
      return {
        dialogVisible: false,
        disabled: false,
        submitLoading: false,
        contentLoading: false,
        model: {
          pkid: 0,
          customerID: "",
          customerGroup: "",
          customerLevel: "",
          customerName: "",
          shortName: "",
          companyNo: "",
          outerNo: "",
          districtId: "",
          address: "",
          industryId: "",
          saleType: "",
          contact: "",
          positionId: "",
          telephone: "",
          fax: "",
          email: "",
          postCode: "",
          note: "",
          bank: "",
          accounts: "",
          vatno: "",
          isPriority: false,
          allowCustomizeDeliveryAddress: false,
          salesOrderSalesApprove: true,
          salesOrderFinApprove: true,
          greenChannel: true,
          belongto: true,
          customerBelongtoEmployeeVOS: [],
          customerDeliveryAddresses: [],
          paymentTypeId: "",
        },
        customerGroups: constant.toSelect(constant.customerGroup),
        customerLevels: constant.toSelect(constant.customerLevel),
        industryList: [],
        payMethods: [],
        dictionaryItemList: [],
        postList: [],
        // ruleValidate: {
        //   customerGroup: { required: true, message: "请选择客户分组", trigger: "change" },
        //   paymentTypeId: { required: true, message: "请选择付款方式", trigger: "change" },
        //   customerLevel: { required: true, message: "请选择客户等级", trigger: "change" },
        //   customerName: { required: true, message: "请输入客户名称", trigger: "blur" },
        //   contact: { required: true, message: "请输入联系人姓名", trigger: "blur" },
        //   districtId: { required: true, message: "请选择所属区域", trigger: "change" },
        //   address: { required: true, message: "请输入详细地址", trigger: "blur" },
        // },
        columns: [
          // {
          //   title: "编号",
          //   key: "employeeNo",
          //   align: "center",
          // },
          {
            title: "姓名",
            key: "employeeName",
            align: "center",
            width: 100,
          },
          {
            title: "性别",
            key: "gender",
            align: "center",
            width: 100,
            render: (h, params) => {
              return h("span", params.row.gender ? "女" : "男");
            },
          },
          {
            title: "类型",
            key: "belongType",
            align: "center",
            slot: "belongType",
          },
          {
            title: "部门",
            key: "departmentName",
            align: "center",
            width: 100,
          },
          {
            title: "是否为默认销售员",
            key: "isDefault",
            align: "center",
            slot: "isDefault",
          },
          {
            title: "操作",
            align: "center",
            width: 80,
            slot: "action",
          },
        ],
        columnsTwo: [
          // {
          //   title: "所属区域",
          //   key: "districtId",
          //   width: 260,
          //   slot: "area",
          // },
          {
            title: "详细地址",
            key: "addressName",
          },
          {
            title: "联系人",
            width: 100,
            key: "contact",
            align: "center",
          },
          {
            title: "联系方式",
            width: 130,
            key: "telephone",
            align: "center",
          },
          {
            title: "是否为默认地址",
            key: "isDefault",
            align: "center",
            slot: "isDefault",
            width: 150,
          },
          {
            title: "操作",
            align: "center",
            width: 80,
            slot: "action",
          },
        ],
      };
    },

    methods: {
      open(row,edit) {
        this.disabled=!edit;
        this.dialogVisible = true;
        this.$nextTick(() => {
          // this.getIndustrys();
          if (row) {
            this.getData(row.customerID);
          }
        });
      },

      getPaymentTypes() {
        this.$http.get("basic", "paymentTypes").then((res) => {
          if (res.success) {
            this.payMethods = res.data;
          }
        });
      },

      getData(customerID) {
        this.contentLoading = true;
        this.$http
          .get("basic", `customers/${customerID}`)
          .then((res) => {
            if (res.success) {
              this.model = Object.assign(this.model, res.data);
              this.model.pkid = res.data.customerID;
              this.model.districtId = res.data.districtId.split(",").map((item) => parseInt(item));
              let arr = res.data.customerDeliveryAddresses;
              if (arr.length) {
                arr.forEach((item) => {
                  item.districtId = item.districtId.split(",").map((item) => parseInt(item));
                });
              }
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 所属行业
      getIndustrys() {
        this.$http.get("basic", "industries/selectAll").then((res) => {
          if (res.success) {
            this.industryList = res.data;
            this.getDictionaryItemList("CUSTOMER_SALE_TYPE");
          }
        });
      },

      // 销售类型
      getDictionaryItemList(type) {
        this.$http.get("basic", `dictionaries/getDictionaryItemList/${type}`).then((resp) => {
          if (resp.success) {
            this.dictionaryItemList = resp.data;
            if (this.dictionaryItemList.length) {
              this.model.saleType = this.dictionaryItemList[0].itemId;
              this.getPosts();
            }
          }
        });
      },

      // 联系人职位
      getPosts() {
        this.$http.get("basic", "posts/list").then((res) => {
          if (res.success) {
            this.postList = res.data;
            this.getPaymentTypes();
          }
        });
      },

      // 所属销售员
      employeeSelect(row) {
        let result = this.model.customerBelongtoEmployeeVOS.find((item) => item.employeeID === row.employeeID);
        if (result) {
          this.$confirm("员工已存在,请勿重复添加！", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        row.belongType=10;//销售员
        row.employeeNo = row.employeeNO;
        let resultTwo = this.model.customerBelongtoEmployeeVOS.find((item) => item.isDefault);
        row.isDefault = !resultTwo;
        this.model.customerBelongtoEmployeeVOS.push(row);
      },

      // 切换默认销售员
      isDefaultChange(row, index) {
        if (row.isDefault) {
          this.model.customerBelongtoEmployeeVOS.forEach((item) => {
            item.isDefault = false;
          });
        }
        this.$set(this.model.customerBelongtoEmployeeVOS, index, row);
      },

      // 收货地址
      deliveryAddressAdd(data) {
        let temp = JSON.parse(data);
        // temp.districtId = JSON.parse(temp.districtId);
        let result = this.model.customerDeliveryAddresses.find((item) => item.isDefault);
        temp.isDefault = !result;
        this.model.customerDeliveryAddresses.push(temp);
      },

      // 切换默认收货地址
      isDefaultChangeTwo(row, index) {
        if (row.isDefault) {
          this.model.customerDeliveryAddresses.forEach((item) => {
            item.isDefault = false;
          });
        }
        this.$set(this.model.customerDeliveryAddresses, index, row);
      },

      // 确定
      handleOk() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.model.customerBelongtoEmployeeVOS.length) {
              this.$confirm("请添加所属销售员", "错误", {
                type: "error",
                showCancelButton: false,
              });
            } else {
              // this.model.districtId = this.model.districtId.join();
              // if (this.model.customerDeliveryAddresses.length) {
              //   this.model.customerDeliveryAddresses.forEach((item) => {
              //     item.districtId = item.districtId.join();
              //   });
              // }
              this.submitLoading = true;
              this.$http
                .save("basic", "customers", this.model)
                .then((res) => {
                  this.submitLoading = false;
                  if (res.success) {
                    if (this.model.pkid) {
                      this.$emit("save-success");
                      this.$message.success("编辑成功");
                    } else {
                      this.$emit("save-success");
                      this.$message.success("添加成功");
                    }
                    this.dialogVisible = false;
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script> 

<style lang="scss" scoped>
.customerEdit .cascader .el-input__inner {
  border: none;
  background-color: transparent !important;
  font-size: 13px;
  color: #515a6e;
}
.customerEdit .cascader .el-input__suffix {
  display: none;
}
</style>
